<template>
	<BaseCard
		:is-editable="!isProcessFinished"
		:title="getRepairExtensionTitle"
		@clickEdit="$router.push({ name: 'damagecases.edit.repairExtensions' })"
		:is-toggle-open="isToggleOpen"
		:is-toggleable="true"
		@toggleCard="toggleCard($event)"
	>
		<template #icons>
			<div class="flex items-center">
				<font-awesome-icon
					icon="exclamation-triangle"
					v-if="ifAnyRepairExtensionIsRequested && $store.getters.isProcessLiability"
					class="text-red-700"
				/>
			</div>
		</template>
		<div v-if="repairExtensions.length">
			<div v-for="(repairExtension, index) in repairExtensions" :key="repairExtension.id">
				<div class="flex justify-between">
					<div class="flex">
						<div class="pr-3 font-bold w-1/3">#{{ repairExtensions.length - index }}</div>
						<div class="w-2/3">{{ getStringFromDateWrapper(new Date(repairExtension.date * 1000)) }}</div>
					</div>
					<div v-if="$store.getters.isProcessLiability">
						<font-awesome-icon
							:icon="['fas', getStatusIconForRepairExtension(repairExtension.status)]"
							class="w-4 h-4"
							:class="getStatusIconColorForRepairExtension(repairExtension.status)"
							size="lg"
						/>
					</div>
				</div>
				<div v-if="repairExtension.description" class="break-words">{{ repairExtension.description }} <br /></div>
			</div>
		</div>
		<div class="font-bold" v-else>
			{{ $t('repair_extensions_not_stored') }}
		</div>
	</BaseCard>
</template>
<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';
import { getStringFromDate } from '@/plugins/Utils';
import { RepairExtensionStatusEnum } from '@/api/generated/models';

export default {
	name: 'RepairExtensionCard',
	components: { BaseCard },
	props: {
		isProcessFinished: {},
		repairExtensions: {},
		isToggleOpen: { type: Boolean, default: true },
		process: { required: true },
	},
	computed: {
		ifAnyRepairExtensionIsRequested() {
			return this.checkIfAnyRepairExtensionIsRequested();
		},
		getRepairExtensionTitle: function() {
			let label = '';
			if (this.repairExtensions.length <= 1) {
				label = this.$t('repair_extension');
			} else {
				label = this.$t('repair_extensions');
			}

			if (this.process.process_type !== 'liability') {
				label = label + ' ' + this.$t('workshop');
			}
			if (this.repairExtensions.length > 1) {
				label = label + ' (' + this.repairExtensions.length + ')';
			}

			return label;
		},
	},
	methods: {
		toggleCard($event) {
			this.$emit('toggleCard', $event);
		},
		checkIfAnyRepairExtensionIsRequested() {
			if (this.repairExtensions.length) {
				for (let i = 0; i < this.repairExtensions.length; i++) {
					if (this.repairExtensions[i].status === RepairExtensionStatusEnum.Requested) {
						return true;
					}
				}
			} else {
				return false;
			}
		},
		getStringFromDateWrapper: function(date) {
			return getStringFromDate(date);
		},
		getStatusIconColorForRepairExtension: function(status) {
			switch (status) {
				case RepairExtensionStatusEnum.Approved:
					return 'text-green-300';
				case RepairExtensionStatusEnum.Rejected:
				case RepairExtensionStatusEnum.Requested:
					return 'text-red-300';
			}
		},
		getStatusIconForRepairExtension: function(status) {
			switch (status) {
				case RepairExtensionStatusEnum.Approved:
					return 'thumbs-up';
				case RepairExtensionStatusEnum.Rejected:
					return 'thumbs-down';
				case RepairExtensionStatusEnum.Requested:
					return 'question';
			}
		},
	},
};
</script>
